export enum EntityKind {
  Well = "Well",
  Facility = "Facility"
}

export type EntityKindKeys = keyof typeof EntityKind;
